import { render, staticRenderFns } from "./Liquidationandrepayment.vue?vue&type=template&id=ff3f85f2&scoped=true"
import script from "./Liquidationandrepayment.vue?vue&type=script&lang=js"
export * from "./Liquidationandrepayment.vue?vue&type=script&lang=js"
import style0 from "./Liquidationandrepayment.vue?vue&type=style&index=0&id=ff3f85f2&prod&lang=css"
import style1 from "./Liquidationandrepayment.vue?vue&type=style&index=1&id=ff3f85f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3f85f2",
  null
  
)

export default component.exports